<template>
    <filters-expansion>
        <v-row>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.buyer_id"
                    :label="buyer.label"
                    :items="buyer.valuesData"
                    hide-no-data
                    cache-items
                    clearable
                    multiple
                    item-text="name"
                    item-value="id"
                    color="teal lighten-2"
                    item-color="teal lighten-2"
                    @change="filterChange"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.seller_id"
                    :label="seller.label"
                    :items="seller.valuesData"
                    hide-no-data
                    cache-items
                    clearable
                    multiple
                    item-text="name"
                    item-value="id"
                    color="teal lighten-2"
                    item-color="teal lighten-2"
                    @change="filterChange"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.product_id"
                    :label="product.label"
                    :items="product.valuesData"
                    hide-no-data
                    cache-items
                    clearable
                    multiple
                    item-text="name"
                    item-value="id"
                    color="teal lighten-2"
                    item-color="teal lighten-2"
                    @change="filterChange"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-menu
                    ref="menu"
                    v-model="datePkr"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="formattedDate"
                            :label="createdAt.label"
                            prepend-icon="mdi-calendar"
                            clearable
                            v-bind="attrs"
                            v-on="on"
                            color="teal lighten-2"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="activeFilters.createdAt"
                        :allowed-dates="allowed"
                        :min="minDate"
                        :max="maxDate"
                        color="teal lighten-2"
                        range
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="teal lighten-2"
                            @click="datePkr = false"
                        >
                            {{ $t('close') }}
                        </v-btn>
                        <v-btn
                            text
                            color="teal lighten-2"
                            @click="dateChange(activeFilters.createdAt)"
                        >
                            {{ $t('set') }}
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <filter-price
                    v-model="activeFilters.price"
                    :min="minPrice"
                    :max="maxPrice"
                    @change="filterChange"
                ></filter-price>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <filter-price
                    v-model="activeFilters.sum"
                    :min="minSum"
                    :max="maxSum"
                    :label="$t('sum')"
                    @change="filterChange"
                ></filter-price>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.status"
                    :label="status.label"
                    :items="status.valuesData"
                    hide-no-data
                    cache-items
                    clearable
                    item-text="name"
                    item-value="id"
                    color="teal lighten-2"
                    item-color="teal lighten-2"
                    @change="filterChange"
                ></v-autocomplete>
            </v-col>
        </v-row>
    </filters-expansion>
</template>

<script>
    import { FilterService } from '../../services';

    import { MixinOrdersGeneral } from '../../mixins';
    import FilterPrice from './FilterPrice';
    import FiltersExpansion from './FiltersExpansion';

    export default {
        name: 'OrderFilters',
        mixins: [MixinOrdersGeneral],
        components: {
            FiltersExpansion,
            FilterPrice,
        },
        data() {
            return {
                datePkr: false,
            }
        },
        computed: {
            buyer() {
                return this.findLayout('buyer');
            },
            seller() {
                return this.findLayout('seller');
            },
            product() {
                return this.findLayout('product');
            },
            createdAt() {
                return this.findLayout('createdAt');
            },
            price() {
                return this.findLayout('price');
            },
            sum() {
                return this.findLayout('sum');
            },
            status() {
                return this.findLayout('status');
            },
            formattedDate: {
                get() {
                    return Array.isArray(this.activeFilters.createdAt)
                        ? this.activeFilters.createdAt
                            .sort()
                            .map(date => new Date(date).toLocaleDateString())
                            .join(' - ')
                        : '';
                },
                set(newVal) {
                    this.activeFilters.createdAt = newVal;
                    this.filterChange();
                },
            },
            minDate() {
                return this.createdAt.valuesData?.min;
            },
            maxDate() {
                return this.createdAt.valuesData?.max;
            },
            minPrice() {
                return this.price.valuesData?.min;
            },
            maxPrice() {
                return this.price.valuesData?.max;
            },
            minSum() {
                return this.sum.valuesData?.min;
            },
            maxSum() {
                return this.sum.valuesData?.max;
            },
        },
        methods: {
            dateChange(date) {
                this.$refs.menu.save(date);
                this.filterChange();
            },
            allowed(date) {
                return this.createdAt.valuesData?.allowed.includes(date);
            },
            findLayout(name) {
                return this.layoutData.find(item => item.systemName === this.ordersFilters[name].systemName) || {};
            },
            getLayout() {
                FilterService.setLocale(this.$store.getters.appLanguage);
                FilterService.getOrdersLayout()
                    .then(res => {
                        this.layoutData = res.data;
                        this.setFiltersFromUrl();
                    })
                    .catch(console.log)
            },
            filterChange() {
                this.addFiltersToUrl(this.activeFilters, this.$route);
                this.$emit('filter-change', { ...this.activeFilters });
            },
            setFiltersFromUrl() {
                this.activeFilters = this.getFiltersFromUrl();
                this.filterChange();
            },
        },
        created() {
            this.getLayout();
        },
    }
</script>

<style scoped>

</style>
